import { graphql } from "react-relay";
import { CalendarStatus } from "@components/calendar-status";
import { AvatarPerson } from "@components/avatar";

export const fragments = {
  org: graphql`
    fragment ProfileUserSummary_org on Org
    @argumentDefinitions(
      calendarId: { type: "String!" }
      calendarIds: { type: "[String]!" }
      timeZone: { type: "String!" }
      rangeMin: { type: "DayTimeSlotInput!" }
      rangeMax: { type: "DayTimeSlotInput!" }
    ) {
      id
      experiments
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            ...CalendarStatus_person
            __typename
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            isUser
          }
        }
      }
      calendarStatusErrorable(calendarId: $calendarId, timeZone: $timeZone) {
        __typename
        ... on CalendarStatus {
          ...CalendarStatus_calendarStatus
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
      profileTimeZonesErrorable(calendarIds: $calendarIds) {
        __typename
        ... on ProfileTimeZoneList {
          list {
            ...CalendarStatus_profileTimeZone
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
      collaboratorStatsErrorable(
        calendarId: $calendarId
        timeZone: $timeZone
        rangeMin: $rangeMin
        rangeMax: $rangeMax
      ) {
        __typename

        ... on GraphEntityError {
          statusCode
        }

        ... on CollaboratorStats {
          calendarId
        }
      }
      suggestedInvites(first: 1000000) {
        edges {
          node {
            targetCalendarId
          }
        }
      }
      pendingInvites(first: 1000000) {
        edges {
          node {
            targetCalendarId
          }
        }
      }
    }
  `,
};
